import React, { FC } from "react";

interface TreatmentKeywordFilterProps {
  onChange: (keyword: string) => void;
  keyword: string;
  placeholder: string;
}

export const TreatmentKeywordFilter: FC<TreatmentKeywordFilterProps> = ({
  onChange,
  keyword,
  placeholder,
}) => {
  return (
    <label className="d-block">
      <span className="label d-block invisible">Søk</span>
      <input
        className="form-control max-width"
        onChange={(e) => onChange(e.target.value)}
        value={keyword}
        placeholder={placeholder}
      />
    </label>
  );
};
